

<!--<div class="row">
  <div class="col-6">
    <span>Thông tin chung</span>
  </div>
  <div class="col-6">
    <div class="full-right">
      <span style="width: 220px;">{{'Tài khoản' | translate}}</span>
      <input class="form-control" [(ngModel)]="hosoSelect.TaiKhoan" disabled="" type="text" style="height: 30px;width: 150px;">
      <button class="btn btn-sm btn-default" (click)="adddata()" style="height: 30px;background: #edf1f2;padding-right: 5px;padding-left: 5px;border-radius: 0px;border: 1px solid #eaeaea !important;" type="button">
        <i class="fa fa-search-plus"></i>
      </button>
    </div>
  </div>
</div>-->



<div class="row ng-scope">

  <div class="col-12">

    <div class="form-group row">
      <label class="col-xl-2 col-form-label">{{'Họ và tên' | translate}}<span class="cred">(*)</span></label>
      <div class="col-xl-2">
        <input type="text" tabindex="1" class="form-control" placeholder="" [(ngModel)]="hosoSelect.HoVaTen">
      </div>
      <div class="col-xl-2">
        <input type="text" tabindex="2" class="form-control" placeholder="Bí danh" [(ngModel)]="hosoSelect.TenGoiKhac">
      </div>
      <label class="col-xl-2 col-form-label">{{'Ngày sinh' | translate}}/{{'Giới tính' | translate}}</label>
      <div class="col-xl-2" style="display: flex; justify-content: space-between;">
        <kendo-dateinput tabindex="3" style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="hosoSelect.NgaySinh"></kendo-dateinput>
      </div>
      <div class="col-xl-2">
        <ng-select [openOnEnter]="false"
                   [items]="inputgioitinhs"
                   bindValue="Id"
                   bindLabel="Name"
                   tabindex="4"
                   notFoundText="Không có dữ liệu"
                   placeholder=""
                   style="width:100px"
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="hosoSelect.GioiTinh">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Name}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>

    </div>


    <div class="form-group row">
      <label class="col-xl-2 col-form-label">{{'Phụ huynh' | translate}}<span class="cred">(*)</span></label>
      <div class="col-xl-4">
        <input type="text" tabindex="5" class="form-control" placeholder="" [(ngModel)]="hosoSelect.NameParent">
      </div>
      <label class="col-xl-2 col-form-label">{{'Điện thoại' | translate}}<span class="cred">(*)</span></label>
      <div class="col-xl-4">
        <input type="text" tabindex="6" class="form-control" placeholder="" [(ngModel)]="hosoSelect.PhoneParent">
      </div>
    </div>


    <div class="form-group row">
      <label class="col-xl-2 col-form-label">{{'Độ tuổi' | translate}} </label>
      <div class="col-xl-4">
        <input type="text" tabindex="7" class="form-control" placeholder="" [(ngModel)]="hosoSelect.DoTuoi">
      </div>
      <label class="col-xl-2 col-form-label">{{'Email' | translate}}</label>
      <div class="col-xl-4">
        <input type="text" tabindex="8" class="form-control" placeholder="" [(ngModel)]="hosoSelect.Email">
      </div>
    </div>

    <div class="form-group row">
      <label class="col-xl-2 col-form-label">{{'Địa chỉ' | translate}} </label>
      <div class="col-xl-4">
        <input type="text" tabindex="9" class="form-control" placeholder="" [(ngModel)]="hosoSelect.NguyenQuan">
      </div>
      <label class="col-xl-2 col-form-label">{{'Trạng thái' | translate}} </label>
      <div class="col-4">
        <ng-select [openOnEnter]="false"
                   [items]="inputtrangthais"
                   bindValue="Id"
                   bindLabel="Ten"
                   tabindex="10"
                   notFoundText="Không có dữ liệu"
                   placeholder=""
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="hosoSelect.TrangThai">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>


    <div class="form-group row">
      <label class="col-xl-2 col-form-label">{{'Chi nhánh' | translate}}<span class="cred">(*)</span></label>
      <div class="col-xl-4">
        <ng-select #slChiNhanh
                   class="twcollong"
                   [tabIndex]="11"
                   [openOnEnter]="false"
                   [items]="dschinhanhs"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   [(ngModel)]="hosoSelect.DonViId">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
      <label class="col-xl-2 col-form-label">{{'Khu vực' | translate}} </label>
      <div class="col-4">
        <ng-select #slKhuVuc
                   class="twcollong"
                   [tabIndex]="12"
                   [openOnEnter]="false"
                   [items]="inputkhuvucs"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="hosoSelect.IDLocations">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell rTableCell-1">{{item.Ma}}</div>
              <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-xl-2 col-form-label">{{'Phụ trách' | translate}}</label>
      <div class="col-xl-4">
        <ng-select #slPhuTrach
                   class="twcollong"
                   [tabIndex]="13"
                   [openOnEnter]="false"
                   [items]="inputGiangViens"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="hosoSelect.IdConsult">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell rTableCell-1">{{item.Ma}}</div>
              <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
      <label class="col-xl-2 col-form-label">{{'Kênh' | translate}} </label>
      <div class="col-xl-4">
        <ng-select [openOnEnter]="false"
                   [items]="inputkenhs"
                   bindValue="Id"
                   bindLabel="Ten"
                   tabindex="14"
                   notFoundText="Không có dữ liệu"
                   placeholder=""
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="hosoSelect.NguonKenh">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>




    <div class="form-group row">
      <label class="col-xl-2 col-form-label">{{'Mạng XH' | translate}} </label>
      <div class="col-xl-4">
        <input type="text" tabindex="15" class="form-control" placeholder="" [(ngModel)]="hosoSelect.FacebookParent">
      </div>
      <label class="col-xl-2 col-form-label">{{'Trình độ' | translate}} </label>
      <div class="col-xl-4">
        <ng-select [openOnEnter]="false"
                   [items]="inputtrinhdos"
                   bindValue="Id"
                   bindLabel="Ten"
                   tabindex="16"
                   notFoundText="Không có dữ liệu"
                   placeholder=""
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="hosoSelect.TrinhDo">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-xl-2 col-form-label">{{'Trường học' | translate}} </label>
      <div class="col-xl-4">
        <input type="text" tabindex="17" class="form-control" placeholder="" [(ngModel)]="hosoSelect.TruongHoc">
      </div>
      <label class="col-xl-2 col-form-label">{{'Hệ đào tạo' | translate}} </label>
      <div class="col-xl-4">
        <ng-select [openOnEnter]="false"
                   [items]="inputhedaotaos"
                   bindValue="Id"
                   bindLabel="Ten"
                   [tabIndex]="18"
                   notFoundText="Không có dữ liệu"
                   placeholder=""
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="hosoSelect.HeDaoTao">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-xl-2 col-form-label">{{'Nguyện vọng' | translate}} </label>
      <div class="col-xl-4">
        <input type="text" tabindex="19" class="form-control" placeholder="" [(ngModel)]="hosoSelect.NguyenVong">
      </div>
      <label class="col-xl-2 col-form-label">{{'Ghi chú' | translate}}</label>
      <div class="col-xl-4">
        <input type="text" tabindex="20" class="form-control" placeholder="" [(ngModel)]="hosoSelect.Notes">
      </div>

    </div>



    





    <div class="form-group row">
      <label class="col-xl-2 col-form-label">{{'Ngày tạo' | translate}}/{{'Người tạo' | translate}}</label>
      <div class="col-xl-2">
        <span>{{hosoSelect.Created | date: 'dd/MM/yyyy HH:mm:ss'}}</span>
      </div>
      <div class="col-xl-2">
        <span>{{hosoSelect.CreatedBy}}</span>
      </div>
      <label class="col-xl-2 col-form-label">{{'Ngày sửa' | translate}}/{{'Người sửa' | translate}}</label>
      <div class="col-xl-2">
        <span>{{hosoSelect.Modified | date: 'dd/MM/yyyy HH:mm:ss'}}</span>
      </div>
      <div class="col-xl-2">
        <span>{{hosoSelect.ModifiedBy}}</span>
      </div>
    </div>




  </div>

</div>

<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    <!--<div class="checkbox c-checkbox">
      <label>
        <input tabIndex="20" type="checkbox" [(ngModel)]="doituongSelect.TrangThai" />
        <span class="fa fa-check"></span> {{'Không sử dụng' | translate}}
      </label>
    </div>-->
  </div>

  <div class="">
    <button style="float:left !important" *ngIf="!(quyen_sua==false && hosoSelect.Id!=null)" type="submit" (click)="saveproduct()" title="" class="mb-1 mr-1 btn btn-primary">{{'Lưu lại' | translate}}</button>
    <button style="float:left !important" class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="">{{'Hủy bỏ' | translate}}</button>
  </div>

</div>


<div id='target' class="control-section">
  <ejs-dialog #dialogObj id='dialog' [visible]='visible' [header]='dialogHeader' [animationSettings]='animationSettings' [showCloseIcon]='showCloseIcon' (open)="dialogOpen()" (close)="dialogClose()"
              [target]='target' [width]='dialogWidth'>
    <ejs-filemanager #filemanagerObj id='filemanager' (beforeSend)="OnbeforeSend($event)"
                     [ajaxSettings]='ajaxSettings' [toolbarSettings]='toolbarSettings'
                     [contextMenuSettings]='contextMenuSettings'
                     [allowMultiSelection]='false' (fileOpen)="onFileOpen($event)" [showThumbnail]="false">
    </ejs-filemanager>
  </ejs-dialog>
</div>

<bs-modal #mdDanhSachLichHoc class="modal fade show in" [cssClass]="'modal7'" [backdrop]="'static'">
  <div class="modal-header">
    <h4 class="modal-title">{{'Danh sách lịch học' | translate}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdDanhSachLichHoc.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-daotao-danhsachlichhocedit #dtedslichhocedit (savect)="save_danhsachlichhoc($event)"></app-daotao-danhsachlichhocedit>
  </bs-modal-body>
</bs-modal>


<bs-modal #modal class="modal fade show in" [cssClass]="'modal7'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">{{'Danh sách tài khoản' | translate}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="modal.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-tonghop-chontaikhoanedit #dteChonTaiKhoan (savect)="savetaikhoan($event)"></app-tonghop-chontaikhoanedit>
  </bs-modal-body>
</bs-modal>
